"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeOptions = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _colors = require("@material-ui/core/colors");
var _commonTheme = _interopRequireDefault(require("./common-theme"));
var _colors2 = require("../colors");
var _shadows = _interopRequireDefault(require("../shadows"));
var _typography = _interopRequireDefault(require("../typography"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var themeOptions = _objectSpread({}, _commonTheme["default"], {
  overrides: _objectSpread({}, _commonTheme["default"].overrides, {
    MuiAppBar: {
      colorPrimary: {
        background: _colors2.primary.main
      }
    },
    MuiButton: {
      containedPrimary: {
        '&:active': {
          backgroundColor: _colors2.opacity.primary[800][62]
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.primary[800][86]
        },
        boxShadow: 'none'
      },
      outlinedPrimary: {
        '&$disabled': {
          borderColor: _colors2.opacity.black[14]
        },
        '&:active': {
          backgroundColor: _colors2.opacity.primary[800][24]
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.primary[800][8],
          borderColor: _colors2.opacity.black[14],
          boxShadow: 'none'
        },
        borderColor: _colors2.opacity.black[14],
        color: _colors2.primary.main
      },
      root: {
        '&:active': {
          backgroundColor: _colors2.opacity.black[14]
        },
        '&:hover': {
          boxShadow: _shadows["default"][5]
        },
        borderRadius: '2px',
        height: '36px',
        minWidth: '88px',
        padding: '0 16px',
        textTransform: 'uppercase'
      },
      sizeLarge: {
        fontSize: '14px',
        padding: '0 16px'
      },
      sizeSmall: {
        fontSize: '12px',
        height: '32px',
        minWidth: '72px',
        padding: '0 8px'
      },
      textPrimary: {
        '&$disabled': {
          borderColor: _colors2.opacity.black[38]
        },
        '&:active': {
          backgroundColor: _colors2.opacity.primary[800][24]
        },
        '&:focus, &:hover': {
          boxShadow: 'none'
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.primary[800][8]
        },
        color: _colors2.primary.main
      }
    },
    MuiCheckbox: {
      root: {
        '&:active': {
          background: _colors2.opacity.black[14]
        },
        '&:hover': {
          background: _colors2.opacity.black[8]
        },
        height: 32,
        padding: 0,
        width: 32
      }
    },
    MuiChip: {
      clickable: {
        '&:active, &:focus': {
          backgroundColor: _colors2.opacity.black[24],
          boxShadow: 'none'
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.black[14]
        }
      },
      deleteIcon: {
        marginLeft: '8px',
        marginRight: '8px'
      },
      icon: {
        marginLeft: '8px',
        marginRight: '8px'
      },
      label: {
        paddingLeft: 0,
        paddingRight: 0
      },
      outlined: {
        border: "1px solid ".concat(_colors2.opacity.black[60]),
        color: _colors2.opacity.black[87]
      },
      root: {
        color: _colors2.opacity.black[87],
        minWidth: '36px'
      }
    },
    MuiCircularProgress: {
      root: {
        color: _colors2.primary.main
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: _colors2.opacity.black[14],
        margin: "".concat(8 / 2, "px 0")
      }
    },
    MuiFormControlLabel: {
      root: {
        marginLeft: -7
      }
    },
    MuiFormLabel: {
      root: {
        color: _colors2.opacity.black[38]
      }
    },
    MuiIconButton: {
      colorPrimary: {
        '&:active': {
          backgroundColor: _colors2.opacity.primary[200][24]
        },
        '&:hover': {
          backgroundColor: _colors2.opacity.primary[200][14]
        },
        color: _colors2.primary[200],
        padding: 0
      },
      colorSecondary: {
        '&:active': {
          color: _colors.common.white
        },
        '&:hover': {
          backgroundColor: 'transparent',
          color: _colors.common.white
        },
        color: _colors2.opacity.white[70],
        padding: 0
      },
      root: {
        '&$disabled': {
          '&:hover, &:active': {
            backgroundColor: 'transparent'
          },
          backgroundColor: 'transparent',
          color: _colors2.opacity.white[50]
        }
      }
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: "2px solid ".concat(_colors2.primary[700])
        },
        '&:before': {
          borderBottom: "1px solid ".concat(_colors2.opacity.black[14])
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: "2px solid ".concat(_colors2.opacity.black[60])
        }
      }
    },
    MuiInputLabel: {
      shrink: {
        transform: 'none'
      }
    },
    MuiLinearProgress: {
      bar: {
        backgroundColor: _colors2.primary.main
      },
      bar1Indeterminate: {
        width: 168
      },
      bar2Indeterminate: {
        width: 168
      },
      colorPrimary: {
        backgroundColor: _colors.lightBlue[100]
      },
      root: {
        height: 4,
        width: 360
      }
    },
    MuiMenuItem: {
      root: _objectSpread({}, _typography["default"].body, {
        height: '12px',
        minHeight: 'auto'
      })
    },
    MuiSwitch: {
      colorPrimary: {
        '&$disabled': {
          color: _colors.common.white
        }
      },
      root: {
        '&$checked': {
          '&:active': {
            background: _colors2.opacity.primary[800][14]
          },
          '&:hover': {
            background: _colors2.opacity.primary[800][8]
          },
          '&disabled': {
            '& $track': {
              color: 'red'
            }
          }
        },
        '&$disabled': {
          '&$switchBase': {
            color: 'red'
          }
        }
      },
      switchBase: {
        '&$checked': {
          '&:active': {
            background: _colors2.opacity.primary[800][14]
          },
          '&:hover': {
            background: _colors2.opacity.primary[800][8]
          }
        },
        '&$checked + $track': {
          opacity: 0.38
        },
        '&$disabled': {
          '& + $track': {
            opacity: 0.38
          },
          '&$checked': {
            '& + $track': {
              backgroundColor: _colors2.primary.main
            },
            color: _colors2.primary.main
          },
          color: _colors.common.white
        },
        '&:active': {
          background: _colors2.opacity.black[14]
        },
        '&:hover': {
          background: _colors2.opacity.black[8]
        },
        color: _colors.common.white,
        height: 32,
        left: 4,
        padding: 6,
        top: 3,
        width: 32
      },
      thumb: {},
      track: {}
    },
    MuiTab: {
      root: {
        paddingBottom: 0
      }
    },
    MuiTableCell: {
      root: {
        minWidth: '124px',
        paddingLeft: 16,
        paddingRight: 16
      }
    }
  }),
  palette: _objectSpread({}, _colors.common.palette, {
    accent: _colors2.accent,
    action: _colors2.action,
    background: _colors2.background,
    contrastThreshold: 3,
    divider: _colors2.opacity.black[14],
    error: _colors2.error,
    opacity: _colors2.opacity,
    // new property added to theme
    primary: _colors2.primary,
    secondary: _colors2.secondary,
    text: _colors2.text,
    tonalOffset: 0.2,
    type: 'dark',
    white: _colors.common.white
  }),
  progress: {
    color: _colors.common.black
  },
  themeType: 'dark'
});
exports.themeOptions = themeOptions;
var _default = themeOptions;
exports["default"] = _default;